<template>
    <div class="home-wrapper" :class="{
        'bg1':targetIdx===0,
        'bg2':targetIdx===1,
        'bg3':targetIdx===2,
        'fadeout': $parent.isFadeout,
        }">
        <audio src="@/assets/audio/book_sound.wav" type="audio/mpeg"
        ref="bookMusic" preload></audio>
        <MainNav :isPc="isPc" :data="tabs"
        :link="targetData.coverstory.link"
        @filp="filp"
        :style="{visibility: navDisplay}"
        :targetIdx="targetIdx"/>
        <MainHeader
        :targetIdx="targetIdx"
        :name="targetData.name"
        :date="targetData.magazine_date"
        :isPlayHeader="$parent.isPlayHeader"/>
        <main class="paper-wrapper" :class="{
        'bg1':targetIdx===0,
        'bg2':targetIdx===1,
        'bg3':targetIdx===2
        }">
            <img src="@/assets/images/tabs/img_tab_dec@3x.png" alt=""
            class="tab-dec fade2" :class="{'active': isfadeInActive}" />
            <!--封面故事-->
            <Section1 id="coverstory" ref="coverstory" :data="targetData.coverstory"
            :isPlayHeader="$parent.isfadeInActive" :isPc="isPc"/>
            <!--教官廣播-->
            <Section2 id="broadcast" ref="broadcast" :data="targetData.broadcast"
            :targetIdx="targetIdx"/>
            <div class="cols-wrapper">
                <!--本月作文-->
                <Section3 id="article" ref="article" :data="targetData.article"
                :targetIdx="targetIdx" />
                <!--學校報告-->
                <Section4 id="report" :data="targetData.report" :targetIdx="targetIdx"/>
            </div>
            <!--擲筊-->
            <Section5 id="divination" ref="divination"
            :data="targetData.divination" :isPc="isPc" :poems="targetData.poems"
            :targetPoemId="targetPoemId"
            :targetIdx="targetIdx"/>
            <!--收音機-->
            <Section6 id="radio" ref="radio" :data="targetData.radio"
            :isPc="isPc" :targetIdx="targetIdx"/>
            <!--底部新聞-->
            <component :is="`Section7${targetIdx}`" id="news" ref="news" :data="targetData.news"
            :targetIdx="targetIdx" v-if="targetIdx !== 3"></component>
        </main>
    </div>
</template>

<script>
import MainNav from '@/components/_MainNav.vue';
import MainHeader from '@/components/_MainHeader.vue';
import Section1 from '@/components/_Section1.vue';
import Section2 from '@/components/_Section2.vue';
import Section3 from '@/components/_Section3.vue';
import Section4 from '@/components/_Section4.vue';
import Section5 from '@/components/_Section5.vue';
import Section6 from '@/components/_Section6.vue';
import Section7 from '@/components/_Section7.vue';
import Section70 from '@/components/_Section7-0.vue';
import Section71 from '@/components/_Section7-1.vue';
import Section72 from '@/components/_Section7-2.vue';
import mixinMethod from '@/js/mixin/mixinMethod';
import apiUrl from '@/api/all';

export default {
    name: 'Home',
    data() {
        return {
            isPc: false,
            urls: apiUrl,
            oriData: {},
            targetIdx: 0,
            // 期刊Id
            targetId: 0,
            // 專欄類別
            targetType: '',
            // 籤詩Id
            targetPoemId: 0,
            targetData: {
                share_link: '',
                share_link_line: '',
                line_text: '',
                // 刊號
                name: '',
                // 左上日期
                magazine_date: '',
                // 封面故事
                coverstory: {
                    title: '',
                    sub_title: '',
                    title_unit: '',
                    title_date: '',
                    title_place: '',
                    title_target: '',
                    content: '',
                    link: '',
                    youtube: '',
                    image_path: '',
                    share_link: '',
                },
                // 教官廣播
                broadcast: {
                    title: '',
                    title_unit: '',
                    content: '',
                    image_path: '',
                    audio_path: '',
                    share_link: '',
                },
                // 本月作文
                article: {
                    title: '',
                    title_unit: '',
                    image_path: '',
                    share_link: '',
                },
                // 學校報告
                report: {
                    title: '',
                    title_unit: '',
                    content: '',
                    images: [],
                    share_link: '',
                },
                // 擲筊
                divination: {
                    title: '',
                    title_unit: '',
                    content: '',
                    share_link: '',
                },
                // 收音機
                radio: {
                    title: '',
                    title_unit: '',
                    content: '',
                    audio_path: '',
                    share_link: '',
                },
                // 底部新聞
                news: [
                    {
                        title: '',
                        title_unit: '',
                        content: '',
                        link: '',
                        image_path: '',
                    },
                ],
                // 籤詩
                poems: [
                    {
                        image_path: '',
                        share_link: '',
                    },
                ],
            },
            tabs: [],
            // Line webView
            isLineWebView: false,
            navDisplay: 'block',
            isfadeInA2: false,
            isfadeInA3: false,
            isfadeInA4: false,
            isfadeInA5: false,
            isfadeInA6: false,
            isfadeInA7: false,
            $a2: null,
            $a3: null,
            $a4: null,
            $a5: null,
            $a6: null,
            $a7: null,
            a2Top: 0,
            a3Top: 0,
            a4Top: 0,
            a5Top: 0,
            a6Top: 0,
            a7Top: 0,
            gap: 0,
        };
    },
    computed: {
        isPlayHeader() {
            return this.$parent.isPlayHeader;
        },
        isfadeInActive() {
            return this.$parent.isfadeInActive;
        },
    },
    mounted() {
        this.isLineWebView = !!window.navigator.userAgent.match('Line');

        this.isPc = window.innerWidth > 768;
        window.addEventListener('resize', () => {
            this.isPc = window.innerWidth > 768;
        });

        this.gap = this.isPc ? window.innerHeight / 3 : window.innerHeight / 3 * 2;
        this.initAnimate();
    },
    methods: {
        toggleNav(isShow) {
            this.navDisplay = isShow ? 'visible' : 'hidden';
        },
        filp(callback) {
            this.$parent.isShowDMW = true;
            window.setTimeout(() => {
                this.toggleParentData('isShowDarkMask');
            }, 800);

            window.setTimeout(() => {
                this.toggleParentData('isFadeout');
            }, 2800);

            window.setTimeout(() => {
                this.triggerBookMusic();
            }, 3700);

            window.setTimeout(() => {
                callback();
            }, 4000);
        },
        query(callback) {
            const vm = this;
            this.targetId = parseInt(this.$route.query.id, 0) || 0;
            this.targetType = this.$route.query.type || '';
            this.targetPoemId = parseInt(this.$route.query.poem, 0) || 0;
            this.targetData.coverstory = {
                title: this.targetData.coverstory.title,
                sub_title: this.targetData.coverstory.sub_title,
                title_unit: this.targetData.coverstory.title_unit,
                title_date: this.targetData.coverstory.title_date,
                title_place: this.targetData.coverstory.title_place,
                title_target: this.targetData.coverstory.title_target,
                content: this.targetData.coverstory.content,
                link: this.targetData.coverstory.link,
                youtube: this.targetData.coverstory.youtube,
                image_path: this.targetData.coverstory.image_path,
                share_link: this.targetData.coverstory.share_link,
            };
            this.targetData.article = {
                title: this.targetData.article.title,
                title_unit: this.targetData.article.title_unit,
                image_path: '',
                share_link: this.targetData.article.share_link,
            };
            if (Object.keys(this.$route.query).length !== 0) this.targetIdx = 3;
            this.$http.get(this.urls.getMagazines).then((ret) => {
                if (ret.data) {
                    vm.oriData = ret.data;
                    this.initAnimate();
                    if (vm.targetId) {
                        const arr = vm.oriData.filter((item, idx) => {
                            const t = item.magazine_id === vm.targetId;
                            if (t) vm.targetIdx = idx;
                            return t;
                        });
                        [vm.targetData] = arr.length ? arr : vm.oriData;
                        if (!arr.length) vm.commonAlert('無此刊號');
                    } else {
                        [vm.targetData] = vm.oriData;
                    }
                    document.querySelector('.video-wrapper').classList.remove('out');

                    if (vm.targetType && vm.targetType in vm.targetData) {
                        window.typeScroll = window.setInterval(() => {
                            const tag = this.$refs[vm.targetType];
                            if (window.scrollY === tag.$el.offsetTop) {
                                window.clearInterval(window.typeScroll);
                                return;
                            }
                            window.scrollTo(0, tag.$el.offsetTop);
                        }, 1000);
                    }

                    if (callback) callback();

                    const tempTabs = vm.oriData.map((item, idx) => {
                        const nItem = {
                            id: item.magazine_id,
                            idx: idx + 1,
                            name: item.name,
                            date: item.magazine_date,
                            remind: item.remind,
                        };
                        return nItem;
                    }).slice(0, 3);

                    const isSameTabs = tempTabs.every((el, idx) => {
                        if (vm.tabs.length && el.id === vm.tabs[idx].id
                        && el.name === vm.tabs[idx].name
                        && el.date === vm.tabs[idx].date) {
                            return true;
                        }
                        return false;
                    });

                    if (!isSameTabs) vm.tabs = tempTabs;

                    if (vm.tabs.length < 3) {
                        for (let i = 0; i <= (3 - vm.tabs.length); i += 1) {
                            vm.tabs.push({
                                id: 0,
                                idx: i + 1,
                                name: vm.tabs.length === 1 ? '暑期刊' : '鬼月刊',
                                date: '',
                                remind: '',
                            });
                        }
                    }
                }
            }, this.errorHandler);
        },
        scrollFadeOut() {
            for (let i = 2; i < 8; i += 1) {
                const className = i !== 7 ? `.article${i}` : '.articles';
                this[`$a${i}`] = document.querySelector(className);
                this[`a${i}Top`] = this[`$a${i}`].offsetTop;
                if (window.scrollY > this[`a${i}Top`] - this.gap && !this[`isfadeInA${i}`]) {
                    this[`isfadeInA${i}`] = true;
                }
            }
        },
        initAnimate() {
            for (let i = 2; i < 8; i += 1) {
                this[`isfadeInA${i}`] = false;
            }

            // 錨點動畫判斷
            window.addEventListener('scroll', this.scrollFadeOut);
        },
        getDate(d, needDay) {
            const date = d ? new Date(d) : new Date();
            const y = date.getFullYear() - 1911;
            const m = date.getMonth() + 1;
            const day = date.getDate();
            let str = `民國${this.toChineseNumeral(y).replace('百零', '〇')}年${this.toChineseNumeral(m)}月`;
            str += needDay ? `${this.toChineseNumeral(day)}日` : '';
            return str;
        },
        onShare(kind, url, lineText) {
            let tempUrl = url || '';
            const tempText = lineText || this.targetData.line_text;
            let goUrl = '';
            if (this.targetIdx === 0) {
                goUrl = 'https://detentionexhibition.udnfunlife.com/#/';
            } else if (this.targetIdx === 1) {
                goUrl = 'https://detentionexhibition.udnfunlife.com/#/?id=16';
            } else if (this.targetIdx === 2) {
                goUrl = 'https://detentionexhibition.udnfunlife.com/#/?id=19';
            }
            let shareUrl = '';
            if (kind === 'fb') {
                if (!tempUrl) tempUrl = this.targetData.share_link;
                shareUrl = `https://www.facebook.com/dialog/feed?app_id=546805856036551&display=popup&link=${encodeURIComponent(tempUrl)}&redirect_uri=${encodeURIComponent(goUrl)}`;
            } else {
                if (!tempUrl) tempUrl = this.targetData.share_link_line;
                shareUrl = `http://line.me/R/msg/text/?${encodeURIComponent(tempText)}%0D%0A${encodeURIComponent(tempUrl)}`;
            }

            this.openNewWindow(shareUrl);
        },
        openNewWindow(url) {
            const windowReference = !this.isLineWebView ? window.open() : null;
            if (windowReference) {
                windowReference.location = url;
            } else {
                window.document.location.href = url;
            }
        },
        cancelOtherMusic(name) {
            const musicList = ['instructorMusic', 'radioMusic', 'noiseMusic', 'youtubeMusic', 'tvVideo'];
            const idx = musicList.indexOf(name);
            let other;

            switch (idx) {
            case 0:
                this.$children[7].stop();
                this.volBgMusic(0);
                break;
            case 1:
                this.$children[3].stop();
                this.volBgMusic(0);
                break;
            case 2:
                this.$children[3].stop();
                this.volBgMusic(0);
                break;
            case 3:
                this.$children[3].stop();
                this.$children[7].stop();
                this.volBgMusic(0);
                break;
            case 4:
                this.$children[7].stop();
                break;
            default:
                break;
            }
            if (other) {
                other.pause();
                other.currentTime = 0;
            }
        },
        volBgMusic(vol) {
            this.$parent.volBgMusic(vol);
        },
        toggleParentData(dataKey) {
            this.$parent[dataKey] = !this.$parent[dataKey];
        },
        triggerBookMusic() {
            this.playAudio('bookMusic');
        },
    },
    watch: {
        '$route.query': {
            handler() {
                this.query();
            },
            deep: true,
            immediate: true,
        },
    },
    mixins: [mixinMethod],
    components: {
        MainNav,
        MainHeader,
        Section1,
        Section2,
        Section3,
        Section4,
        Section5,
        Section6,
        Section7,
        Section70,
        Section71,
        Section72,
    },
};

</script>
